/** Returns [user_id, request_id, url_key] from a public share pathname. */
export const splitUrl = (pathname) => pathname.split('/s/')[1].split('.')

/** Returns the compound key `userId.requestId.urlKey` after `/s/`. */
export const getCompoundKey = (pathname) => pathname.split('/s/').reverse()[0]
